import { createContext } from "react";

export const defaultState = { currentUser: null };

export default createContext(defaultState);
